import { createRoot } from 'react-dom/client';
import App from './App';
import { startSyncLoop } from './sync';
import './styles.css';

// Просим систему не выселять наше хранилище: на iOS оно может быть вычищено,
// если приложением не пользоваться, а внутри лежат несинхронизированные съёмки.
void navigator.storage?.persist?.().catch(() => {});

startSyncLoop();

createRoot(document.getElementById('root')!).render(<App />);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
